import React, { useState, useEffect, useContext } from 'react';
import { InputContext } from './InputContext';
import './RecipeActionButton.css';

const baseURL = process.env.REACT_APP_API_URL;


function SaveButton({ recipeId }) {
  const [saved, setSaved] = useState(false);
  const { username } = useContext(InputContext);

  useEffect(() => {
    if (!username) return;
    
    const checkSavedStatus = async () => {
      try {
        const response = await fetch(`${baseURL}/recipes/saved-recipes/${username}`);
        if (response.ok) {
          const data = await response.json();
          setSaved(data.some(recipe => recipe._id === recipeId));
        }
      } catch (err) {
        console.error('Error checking saved status:', err);
      }
    };

    checkSavedStatus();
  }, [username, recipeId]);

  const toggleSave = async () => {
    console.log("Toggling save for:", recipeId, "user:", username);
    try {
      const response = await fetch(`${baseURL}/recipes/saved-recipes/${username}`, {
        method: saved ? 'DELETE' : 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ recipeId })
      });

      if (response.ok) {
        setSaved(!saved);
      }
    } catch (err) {
      console.error('Error toggling save:', err);
    }
  };

  return (
    <button
      className={`recipe-button ${saved ? 'saved' : ''}`}
      onClick={toggleSave}
    >
      {saved ? '✅ Saved' : '🔖 Save'}
    </button>
  );
}

export default SaveButton;